// source: proto/marginpb/requirement.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_type_date_pb = require('../../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js');
goog.object.extend(proto, proto_utilspb_pagination_pb);
goog.exportSymbol('proto.marginpb.ListRequirementDetailRequest', null, global);
goog.exportSymbol('proto.marginpb.ListRequirementDetailResponse', null, global);
goog.exportSymbol('proto.marginpb.ListRequirementRequest', null, global);
goog.exportSymbol('proto.marginpb.ListRequirementResponse', null, global);
goog.exportSymbol('proto.marginpb.Requirement', null, global);
goog.exportSymbol('proto.marginpb.RequirementDetail', null, global);
goog.exportSymbol('proto.marginpb.RequirementDetailSummary', null, global);
goog.exportSymbol('proto.marginpb.RequirementSummary', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.marginpb.Requirement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.marginpb.Requirement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.marginpb.Requirement.displayName = 'proto.marginpb.Requirement';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.marginpb.RequirementDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.marginpb.RequirementDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.marginpb.RequirementDetail.displayName = 'proto.marginpb.RequirementDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.marginpb.ListRequirementRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.marginpb.ListRequirementRequest.repeatedFields_, null);
};
goog.inherits(proto.marginpb.ListRequirementRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.marginpb.ListRequirementRequest.displayName = 'proto.marginpb.ListRequirementRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.marginpb.ListRequirementResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.marginpb.ListRequirementResponse.repeatedFields_, null);
};
goog.inherits(proto.marginpb.ListRequirementResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.marginpb.ListRequirementResponse.displayName = 'proto.marginpb.ListRequirementResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.marginpb.RequirementSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.marginpb.RequirementSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.marginpb.RequirementSummary.displayName = 'proto.marginpb.RequirementSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.marginpb.ListRequirementDetailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.marginpb.ListRequirementDetailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.marginpb.ListRequirementDetailRequest.displayName = 'proto.marginpb.ListRequirementDetailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.marginpb.ListRequirementDetailResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.marginpb.ListRequirementDetailResponse.repeatedFields_, null);
};
goog.inherits(proto.marginpb.ListRequirementDetailResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.marginpb.ListRequirementDetailResponse.displayName = 'proto.marginpb.ListRequirementDetailResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.marginpb.RequirementDetailSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.marginpb.RequirementDetailSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.marginpb.RequirementDetailSummary.displayName = 'proto.marginpb.RequirementDetailSummary';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.marginpb.Requirement.prototype.toObject = function(opt_includeInstance) {
  return proto.marginpb.Requirement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.marginpb.Requirement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marginpb.Requirement.toObject = function(includeInstance, msg) {
  var f, obj = {
    requirementId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tradeDate: (f = msg.getTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    accountId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    correspondent: jspb.Message.getFieldWithDefault(msg, 4, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 5, ""),
    accountName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    marginType: jspb.Message.getFieldWithDefault(msg, 7, ""),
    cashBalance: jspb.Message.getFieldWithDefault(msg, 8, ""),
    longMarketValue: jspb.Message.getFieldWithDefault(msg, 9, ""),
    shortMarketValue: jspb.Message.getFieldWithDefault(msg, 10, ""),
    totalEquity: jspb.Message.getFieldWithDefault(msg, 11, ""),
    marketValue: jspb.Message.getFieldWithDefault(msg, 12, ""),
    exchangeReq: jspb.Message.getFieldWithDefault(msg, 13, ""),
    exchangeCall: jspb.Message.getFieldWithDefault(msg, 14, ""),
    fedReq: jspb.Message.getFieldWithDefault(msg, 15, ""),
    fedCall: jspb.Message.getFieldWithDefault(msg, 16, ""),
    houseReq: jspb.Message.getFieldWithDefault(msg, 17, ""),
    houseCall: jspb.Message.getFieldWithDefault(msg, 18, ""),
    buyingPowerCall: jspb.Message.getFieldWithDefault(msg, 19, ""),
    minBalanceCall: jspb.Message.getFieldWithDefault(msg, 20, ""),
    sma: jspb.Message.getFieldWithDefault(msg, 21, ""),
    buyingPower: jspb.Message.getFieldWithDefault(msg, 22, ""),
    multiplier: jspb.Message.getFieldWithDefault(msg, 23, ""),
    buyingPowerUsed: jspb.Message.getFieldWithDefault(msg, 24, ""),
    houseExcess: jspb.Message.getFieldWithDefault(msg, 25, ""),
    adjFedReq: jspb.Message.getFieldWithDefault(msg, 26, ""),
    adjExchangeReq: jspb.Message.getFieldWithDefault(msg, 27, ""),
    adjHouseReq: jspb.Message.getFieldWithDefault(msg, 28, ""),
    longOptionMarketValue: jspb.Message.getFieldWithDefault(msg, 29, ""),
    shortOptionMarketValue: jspb.Message.getFieldWithDefault(msg, 30, ""),
    pmHouseCall: jspb.Message.getFieldWithDefault(msg, 31, ""),
    pmHouseReq: jspb.Message.getFieldWithDefault(msg, 32, ""),
    timsCall: jspb.Message.getFieldWithDefault(msg, 33, ""),
    timsReq: jspb.Message.getFieldWithDefault(msg, 34, ""),
    marginEquity: jspb.Message.getFieldWithDefault(msg, 35, ""),
    fedExcess: jspb.Message.getFieldWithDefault(msg, 36, ""),
    exchangeExcess: jspb.Message.getFieldWithDefault(msg, 37, ""),
    minBalanceExcess: jspb.Message.getFieldWithDefault(msg, 38, ""),
    minBalanceReq: jspb.Message.getFieldWithDefault(msg, 39, ""),
    totalAdjustmentFedReq: jspb.Message.getFieldWithDefault(msg, 40, ""),
    totalAdjustmentHouseReq: jspb.Message.getFieldWithDefault(msg, 41, ""),
    totalAdjustmentExchangeReq: jspb.Message.getFieldWithDefault(msg, 42, ""),
    cashCallReq: jspb.Message.getFieldWithDefault(msg, 43, ""),
    cashCall: jspb.Message.getFieldWithDefault(msg, 44, ""),
    freeRidingReq: jspb.Message.getFieldWithDefault(msg, 45, ""),
    freeRidingCall: jspb.Message.getFieldWithDefault(msg, 46, ""),
    overnightBuyingPower: jspb.Message.getFieldWithDefault(msg, 47, ""),
    pmHouseExcess: jspb.Message.getFieldWithDefault(msg, 48, ""),
    timsExcess: jspb.Message.getFieldWithDefault(msg, 49, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.marginpb.Requirement}
 */
proto.marginpb.Requirement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.marginpb.Requirement;
  return proto.marginpb.Requirement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.marginpb.Requirement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.marginpb.Requirement}
 */
proto.marginpb.Requirement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRequirementId(value);
      break;
    case 2:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setTradeDate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCashBalance(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongMarketValue(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortMarketValue(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalEquity(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketValue(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchangeReq(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchangeCall(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setFedReq(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setFedCall(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setHouseReq(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setHouseCall(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuyingPowerCall(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinBalanceCall(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setSma(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuyingPower(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setMultiplier(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuyingPowerUsed(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setHouseExcess(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjFedReq(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjExchangeReq(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjHouseReq(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongOptionMarketValue(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortOptionMarketValue(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setPmHouseCall(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setPmHouseReq(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimsCall(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimsReq(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginEquity(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setFedExcess(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchangeExcess(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinBalanceExcess(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinBalanceReq(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalAdjustmentFedReq(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalAdjustmentHouseReq(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalAdjustmentExchangeReq(value);
      break;
    case 43:
      var value = /** @type {string} */ (reader.readString());
      msg.setCashCallReq(value);
      break;
    case 44:
      var value = /** @type {string} */ (reader.readString());
      msg.setCashCall(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setFreeRidingReq(value);
      break;
    case 46:
      var value = /** @type {string} */ (reader.readString());
      msg.setFreeRidingCall(value);
      break;
    case 47:
      var value = /** @type {string} */ (reader.readString());
      msg.setOvernightBuyingPower(value);
      break;
    case 48:
      var value = /** @type {string} */ (reader.readString());
      msg.setPmHouseExcess(value);
      break;
    case 49:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimsExcess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.marginpb.Requirement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.marginpb.Requirement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.marginpb.Requirement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marginpb.Requirement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequirementId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getTradeDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMarginType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCashBalance();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTotalEquity();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getMarketValue();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getExchangeReq();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getExchangeCall();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getFedReq();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getFedCall();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getHouseReq();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getHouseCall();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getBuyingPowerCall();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getMinBalanceCall();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getSma();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getBuyingPower();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getMultiplier();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getBuyingPowerUsed();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getHouseExcess();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getAdjFedReq();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getAdjExchangeReq();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getAdjHouseReq();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getLongOptionMarketValue();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getShortOptionMarketValue();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getPmHouseCall();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getPmHouseReq();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getTimsCall();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getTimsReq();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getMarginEquity();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getFedExcess();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getExchangeExcess();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getMinBalanceExcess();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getMinBalanceReq();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getTotalAdjustmentFedReq();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getTotalAdjustmentHouseReq();
  if (f.length > 0) {
    writer.writeString(
      41,
      f
    );
  }
  f = message.getTotalAdjustmentExchangeReq();
  if (f.length > 0) {
    writer.writeString(
      42,
      f
    );
  }
  f = message.getCashCallReq();
  if (f.length > 0) {
    writer.writeString(
      43,
      f
    );
  }
  f = message.getCashCall();
  if (f.length > 0) {
    writer.writeString(
      44,
      f
    );
  }
  f = message.getFreeRidingReq();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
  f = message.getFreeRidingCall();
  if (f.length > 0) {
    writer.writeString(
      46,
      f
    );
  }
  f = message.getOvernightBuyingPower();
  if (f.length > 0) {
    writer.writeString(
      47,
      f
    );
  }
  f = message.getPmHouseExcess();
  if (f.length > 0) {
    writer.writeString(
      48,
      f
    );
  }
  f = message.getTimsExcess();
  if (f.length > 0) {
    writer.writeString(
      49,
      f
    );
  }
};


/**
 * optional uint32 requirement_id = 1;
 * @return {number}
 */
proto.marginpb.Requirement.prototype.getRequirementId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setRequirementId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.type.Date trade_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.marginpb.Requirement.prototype.getTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 2));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.marginpb.Requirement} returns this
*/
proto.marginpb.Requirement.prototype.setTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.clearTradeDate = function() {
  return this.setTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.marginpb.Requirement.prototype.hasTradeDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint32 account_id = 3;
 * @return {number}
 */
proto.marginpb.Requirement.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string correspondent = 4;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string master_account_no = 5;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string account_name = 6;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string margin_type = 7;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getMarginType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setMarginType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string cash_balance = 8;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getCashBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setCashBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string long_market_value = 9;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string short_market_value = 10;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string total_equity = 11;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getTotalEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setTotalEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string market_value = 12;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string exchange_req = 13;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getExchangeReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setExchangeReq = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string exchange_call = 14;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getExchangeCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setExchangeCall = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string fed_req = 15;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getFedReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setFedReq = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string fed_call = 16;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getFedCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setFedCall = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string house_req = 17;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string house_call = 18;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getHouseCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setHouseCall = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string buying_power_call = 19;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getBuyingPowerCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setBuyingPowerCall = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string min_balance_call = 20;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getMinBalanceCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setMinBalanceCall = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string sma = 21;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getSma = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setSma = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string buying_power = 22;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getBuyingPower = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setBuyingPower = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string multiplier = 23;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getMultiplier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setMultiplier = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string buying_power_used = 24;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getBuyingPowerUsed = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setBuyingPowerUsed = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string house_excess = 25;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getHouseExcess = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setHouseExcess = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string adj_fed_req = 26;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getAdjFedReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setAdjFedReq = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string adj_exchange_req = 27;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getAdjExchangeReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setAdjExchangeReq = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string adj_house_req = 28;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getAdjHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setAdjHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string long_option_market_value = 29;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getLongOptionMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setLongOptionMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string short_option_market_value = 30;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getShortOptionMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setShortOptionMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string pm_house_call = 31;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getPmHouseCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setPmHouseCall = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string pm_house_req = 32;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getPmHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setPmHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string tims_call = 33;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getTimsCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setTimsCall = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional string tims_req = 34;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getTimsReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setTimsReq = function(value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional string margin_equity = 35;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getMarginEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setMarginEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string fed_excess = 36;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getFedExcess = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setFedExcess = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string exchange_excess = 37;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getExchangeExcess = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setExchangeExcess = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string min_balance_excess = 38;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getMinBalanceExcess = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setMinBalanceExcess = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string min_balance_req = 39;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getMinBalanceReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setMinBalanceReq = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional string total_adjustment_fed_req = 40;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getTotalAdjustmentFedReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setTotalAdjustmentFedReq = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional string total_adjustment_house_req = 41;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getTotalAdjustmentHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setTotalAdjustmentHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 41, value);
};


/**
 * optional string total_adjustment_exchange_req = 42;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getTotalAdjustmentExchangeReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setTotalAdjustmentExchangeReq = function(value) {
  return jspb.Message.setProto3StringField(this, 42, value);
};


/**
 * optional string cash_call_req = 43;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getCashCallReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setCashCallReq = function(value) {
  return jspb.Message.setProto3StringField(this, 43, value);
};


/**
 * optional string cash_call = 44;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getCashCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setCashCall = function(value) {
  return jspb.Message.setProto3StringField(this, 44, value);
};


/**
 * optional string free_riding_req = 45;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getFreeRidingReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setFreeRidingReq = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};


/**
 * optional string free_riding_call = 46;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getFreeRidingCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 46, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setFreeRidingCall = function(value) {
  return jspb.Message.setProto3StringField(this, 46, value);
};


/**
 * optional string overnight_buying_power = 47;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getOvernightBuyingPower = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setOvernightBuyingPower = function(value) {
  return jspb.Message.setProto3StringField(this, 47, value);
};


/**
 * optional string pm_house_excess = 48;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getPmHouseExcess = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 48, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setPmHouseExcess = function(value) {
  return jspb.Message.setProto3StringField(this, 48, value);
};


/**
 * optional string tims_excess = 49;
 * @return {string}
 */
proto.marginpb.Requirement.prototype.getTimsExcess = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 49, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.Requirement} returns this
 */
proto.marginpb.Requirement.prototype.setTimsExcess = function(value) {
  return jspb.Message.setProto3StringField(this, 49, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.marginpb.RequirementDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.marginpb.RequirementDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.marginpb.RequirementDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marginpb.RequirementDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    requirementId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tradeDate: (f = msg.getTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    accountId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    correspondent: jspb.Message.getFieldWithDefault(msg, 4, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 5, ""),
    accountName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    marginType: jspb.Message.getFieldWithDefault(msg, 7, ""),
    originalCusip: jspb.Message.getFieldWithDefault(msg, 8, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 9, ""),
    cusip: jspb.Message.getFieldWithDefault(msg, 10, ""),
    symbolDescription: jspb.Message.getFieldWithDefault(msg, 11, ""),
    marginable: jspb.Message.getFieldWithDefault(msg, 12, ""),
    leveragedFactor: jspb.Message.getFieldWithDefault(msg, 13, ""),
    closingPrice: jspb.Message.getFieldWithDefault(msg, 14, ""),
    longQty: jspb.Message.getFieldWithDefault(msg, 15, ""),
    shortQty: jspb.Message.getFieldWithDefault(msg, 16, ""),
    qty: jspb.Message.getFieldWithDefault(msg, 17, ""),
    previousQty: jspb.Message.getFieldWithDefault(msg, 18, ""),
    longMarketValue: jspb.Message.getFieldWithDefault(msg, 19, ""),
    shortMarketValue: jspb.Message.getFieldWithDefault(msg, 20, ""),
    marketValue: jspb.Message.getFieldWithDefault(msg, 21, ""),
    previousMarketValue: jspb.Message.getFieldWithDefault(msg, 22, ""),
    exchangeReq: jspb.Message.getFieldWithDefault(msg, 23, ""),
    exchangeRate: jspb.Message.getFieldWithDefault(msg, 24, ""),
    houseReq: jspb.Message.getFieldWithDefault(msg, 25, ""),
    houseRate: jspb.Message.getFieldWithDefault(msg, 26, ""),
    fedReq: jspb.Message.getFieldWithDefault(msg, 27, ""),
    fedRate: jspb.Message.getFieldWithDefault(msg, 28, ""),
    assetType: jspb.Message.getFieldWithDefault(msg, 29, ""),
    costPrice: jspb.Message.getFieldWithDefault(msg, 31, ""),
    costBasis: jspb.Message.getFieldWithDefault(msg, 32, ""),
    subAccountType: jspb.Message.getFieldWithDefault(msg, 33, 0),
    adjFedReq: jspb.Message.getFieldWithDefault(msg, 34, ""),
    adjExchangeReq: jspb.Message.getFieldWithDefault(msg, 35, ""),
    adjHouseReq: jspb.Message.getFieldWithDefault(msg, 36, ""),
    longOptionMarketValue: jspb.Message.getFieldWithDefault(msg, 37, ""),
    shortOptionMarketValue: jspb.Message.getFieldWithDefault(msg, 38, ""),
    pmHouseRate: jspb.Message.getFieldWithDefault(msg, 39, ""),
    pmHouseReq: jspb.Message.getFieldWithDefault(msg, 40, ""),
    timsRate: jspb.Message.getFieldWithDefault(msg, 41, ""),
    timsReq: jspb.Message.getFieldWithDefault(msg, 42, ""),
    totalAdjustmentFedReq: jspb.Message.getFieldWithDefault(msg, 43, ""),
    totalAdjustmentHouseReq: jspb.Message.getFieldWithDefault(msg, 44, ""),
    totalAdjustmentExchangeReq: jspb.Message.getFieldWithDefault(msg, 45, ""),
    side: jspb.Message.getFieldWithDefault(msg, 46, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.marginpb.RequirementDetail}
 */
proto.marginpb.RequirementDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.marginpb.RequirementDetail;
  return proto.marginpb.RequirementDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.marginpb.RequirementDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.marginpb.RequirementDetail}
 */
proto.marginpb.RequirementDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRequirementId(value);
      break;
    case 2:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setTradeDate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginalCusip(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCusip(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolDescription(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginable(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeveragedFactor(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setClosingPrice(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongQty(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortQty(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setQty(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviousQty(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongMarketValue(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortMarketValue(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketValue(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviousMarketValue(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchangeReq(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchangeRate(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setHouseReq(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setHouseRate(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setFedReq(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setFedRate(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetType(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setCostPrice(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setCostBasis(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSubAccountType(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjFedReq(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjExchangeReq(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjHouseReq(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongOptionMarketValue(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortOptionMarketValue(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setPmHouseRate(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setPmHouseReq(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimsRate(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimsReq(value);
      break;
    case 43:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalAdjustmentFedReq(value);
      break;
    case 44:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalAdjustmentHouseReq(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalAdjustmentExchangeReq(value);
      break;
    case 46:
      var value = /** @type {string} */ (reader.readString());
      msg.setSide(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.marginpb.RequirementDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.marginpb.RequirementDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.marginpb.RequirementDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marginpb.RequirementDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequirementId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getTradeDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMarginType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCusip();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSymbolDescription();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getMarginable();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getLeveragedFactor();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getClosingPrice();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getLongQty();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getShortQty();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getQty();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getPreviousQty();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getMarketValue();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getPreviousMarketValue();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getExchangeReq();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getExchangeRate();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getHouseReq();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getHouseRate();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getFedReq();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getFedRate();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getAssetType();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getCostPrice();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getCostBasis();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getSubAccountType();
  if (f !== 0) {
    writer.writeUint32(
      33,
      f
    );
  }
  f = message.getAdjFedReq();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getAdjExchangeReq();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getAdjHouseReq();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getLongOptionMarketValue();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getShortOptionMarketValue();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getPmHouseRate();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getPmHouseReq();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getTimsRate();
  if (f.length > 0) {
    writer.writeString(
      41,
      f
    );
  }
  f = message.getTimsReq();
  if (f.length > 0) {
    writer.writeString(
      42,
      f
    );
  }
  f = message.getTotalAdjustmentFedReq();
  if (f.length > 0) {
    writer.writeString(
      43,
      f
    );
  }
  f = message.getTotalAdjustmentHouseReq();
  if (f.length > 0) {
    writer.writeString(
      44,
      f
    );
  }
  f = message.getTotalAdjustmentExchangeReq();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
  f = message.getSide();
  if (f.length > 0) {
    writer.writeString(
      46,
      f
    );
  }
};


/**
 * optional uint32 requirement_id = 1;
 * @return {number}
 */
proto.marginpb.RequirementDetail.prototype.getRequirementId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setRequirementId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.type.Date trade_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.marginpb.RequirementDetail.prototype.getTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 2));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.marginpb.RequirementDetail} returns this
*/
proto.marginpb.RequirementDetail.prototype.setTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.clearTradeDate = function() {
  return this.setTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.marginpb.RequirementDetail.prototype.hasTradeDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint32 account_id = 3;
 * @return {number}
 */
proto.marginpb.RequirementDetail.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string correspondent = 4;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string master_account_no = 5;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string account_name = 6;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string margin_type = 7;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getMarginType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setMarginType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string original_cusip = 8;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getOriginalCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setOriginalCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string symbol = 9;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string cusip = 10;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string symbol_description = 11;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getSymbolDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setSymbolDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string marginable = 12;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getMarginable = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setMarginable = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string leveraged_factor = 13;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getLeveragedFactor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setLeveragedFactor = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string closing_price = 14;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getClosingPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setClosingPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string long_qty = 15;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getLongQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setLongQty = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string short_qty = 16;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getShortQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setShortQty = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string qty = 17;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setQty = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string previous_qty = 18;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getPreviousQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setPreviousQty = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string long_market_value = 19;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string short_market_value = 20;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string market_value = 21;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string previous_market_value = 22;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getPreviousMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setPreviousMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string exchange_req = 23;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getExchangeReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setExchangeReq = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string exchange_rate = 24;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getExchangeRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setExchangeRate = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string house_req = 25;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string house_rate = 26;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getHouseRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setHouseRate = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string fed_req = 27;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getFedReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setFedReq = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string fed_rate = 28;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getFedRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setFedRate = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string asset_type = 29;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getAssetType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setAssetType = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string cost_price = 31;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getCostPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setCostPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string cost_basis = 32;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getCostBasis = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setCostBasis = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional uint32 sub_account_type = 33;
 * @return {number}
 */
proto.marginpb.RequirementDetail.prototype.getSubAccountType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {number} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setSubAccountType = function(value) {
  return jspb.Message.setProto3IntField(this, 33, value);
};


/**
 * optional string adj_fed_req = 34;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getAdjFedReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setAdjFedReq = function(value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional string adj_exchange_req = 35;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getAdjExchangeReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setAdjExchangeReq = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string adj_house_req = 36;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getAdjHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setAdjHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string long_option_market_value = 37;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getLongOptionMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setLongOptionMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string short_option_market_value = 38;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getShortOptionMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setShortOptionMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string pm_house_rate = 39;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getPmHouseRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setPmHouseRate = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional string pm_house_req = 40;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getPmHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setPmHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional string tims_rate = 41;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getTimsRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setTimsRate = function(value) {
  return jspb.Message.setProto3StringField(this, 41, value);
};


/**
 * optional string tims_req = 42;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getTimsReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setTimsReq = function(value) {
  return jspb.Message.setProto3StringField(this, 42, value);
};


/**
 * optional string total_adjustment_fed_req = 43;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getTotalAdjustmentFedReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setTotalAdjustmentFedReq = function(value) {
  return jspb.Message.setProto3StringField(this, 43, value);
};


/**
 * optional string total_adjustment_house_req = 44;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getTotalAdjustmentHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setTotalAdjustmentHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 44, value);
};


/**
 * optional string total_adjustment_exchange_req = 45;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getTotalAdjustmentExchangeReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setTotalAdjustmentExchangeReq = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};


/**
 * optional string side = 46;
 * @return {string}
 */
proto.marginpb.RequirementDetail.prototype.getSide = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 46, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetail} returns this
 */
proto.marginpb.RequirementDetail.prototype.setSide = function(value) {
  return jspb.Message.setProto3StringField(this, 46, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.marginpb.ListRequirementRequest.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.marginpb.ListRequirementRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.marginpb.ListRequirementRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.marginpb.ListRequirementRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marginpb.ListRequirementRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tradeDate: (f = msg.getTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accountName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    correspondent: jspb.Message.getFieldWithDefault(msg, 4, ""),
    usrId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    marginType: jspb.Message.getFieldWithDefault(msg, 6, ""),
    fieldsNotZeroList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    pagination: (f = msg.getPagination()) && proto_utilspb_pagination_pb.Pagination.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.marginpb.ListRequirementRequest}
 */
proto.marginpb.ListRequirementRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.marginpb.ListRequirementRequest;
  return proto.marginpb.ListRequirementRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.marginpb.ListRequirementRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.marginpb.ListRequirementRequest}
 */
proto.marginpb.ListRequirementRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setTradeDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUsrId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginType(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addFieldsNotZero(value);
      break;
    case 8:
      var value = new proto_utilspb_pagination_pb.Pagination;
      reader.readMessage(value,proto_utilspb_pagination_pb.Pagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.marginpb.ListRequirementRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.marginpb.ListRequirementRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.marginpb.ListRequirementRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marginpb.ListRequirementRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTradeDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUsrId();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getMarginType();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFieldsNotZeroList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto_utilspb_pagination_pb.Pagination.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.type.Date trade_date = 1;
 * @return {?proto.google.type.Date}
 */
proto.marginpb.ListRequirementRequest.prototype.getTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.marginpb.ListRequirementRequest} returns this
*/
proto.marginpb.ListRequirementRequest.prototype.setTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.marginpb.ListRequirementRequest} returns this
 */
proto.marginpb.ListRequirementRequest.prototype.clearTradeDate = function() {
  return this.setTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.marginpb.ListRequirementRequest.prototype.hasTradeDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string master_account_no = 2;
 * @return {string}
 */
proto.marginpb.ListRequirementRequest.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.ListRequirementRequest} returns this
 */
proto.marginpb.ListRequirementRequest.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string account_name = 3;
 * @return {string}
 */
proto.marginpb.ListRequirementRequest.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.ListRequirementRequest} returns this
 */
proto.marginpb.ListRequirementRequest.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string correspondent = 4;
 * @return {string}
 */
proto.marginpb.ListRequirementRequest.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.ListRequirementRequest} returns this
 */
proto.marginpb.ListRequirementRequest.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 usr_id = 5;
 * @return {number}
 */
proto.marginpb.ListRequirementRequest.prototype.getUsrId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.marginpb.ListRequirementRequest} returns this
 */
proto.marginpb.ListRequirementRequest.prototype.setUsrId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string margin_type = 6;
 * @return {string}
 */
proto.marginpb.ListRequirementRequest.prototype.getMarginType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.ListRequirementRequest} returns this
 */
proto.marginpb.ListRequirementRequest.prototype.setMarginType = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated string fields_not_zero = 7;
 * @return {!Array<string>}
 */
proto.marginpb.ListRequirementRequest.prototype.getFieldsNotZeroList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.marginpb.ListRequirementRequest} returns this
 */
proto.marginpb.ListRequirementRequest.prototype.setFieldsNotZeroList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.marginpb.ListRequirementRequest} returns this
 */
proto.marginpb.ListRequirementRequest.prototype.addFieldsNotZero = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.marginpb.ListRequirementRequest} returns this
 */
proto.marginpb.ListRequirementRequest.prototype.clearFieldsNotZeroList = function() {
  return this.setFieldsNotZeroList([]);
};


/**
 * optional utilspb.Pagination pagination = 8;
 * @return {?proto.utilspb.Pagination}
 */
proto.marginpb.ListRequirementRequest.prototype.getPagination = function() {
  return /** @type{?proto.utilspb.Pagination} */ (
    jspb.Message.getWrapperField(this, proto_utilspb_pagination_pb.Pagination, 8));
};


/**
 * @param {?proto.utilspb.Pagination|undefined} value
 * @return {!proto.marginpb.ListRequirementRequest} returns this
*/
proto.marginpb.ListRequirementRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.marginpb.ListRequirementRequest} returns this
 */
proto.marginpb.ListRequirementRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.marginpb.ListRequirementRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.marginpb.ListRequirementResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.marginpb.ListRequirementResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.marginpb.ListRequirementResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.marginpb.ListRequirementResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marginpb.ListRequirementResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requirementsList: jspb.Message.toObjectList(msg.getRequirementsList(),
    proto.marginpb.Requirement.toObject, includeInstance),
    summary: (f = msg.getSummary()) && proto.marginpb.RequirementSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.marginpb.ListRequirementResponse}
 */
proto.marginpb.ListRequirementResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.marginpb.ListRequirementResponse;
  return proto.marginpb.ListRequirementResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.marginpb.ListRequirementResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.marginpb.ListRequirementResponse}
 */
proto.marginpb.ListRequirementResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.marginpb.Requirement;
      reader.readMessage(value,proto.marginpb.Requirement.deserializeBinaryFromReader);
      msg.addRequirements(value);
      break;
    case 2:
      var value = new proto.marginpb.RequirementSummary;
      reader.readMessage(value,proto.marginpb.RequirementSummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.marginpb.ListRequirementResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.marginpb.ListRequirementResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.marginpb.ListRequirementResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marginpb.ListRequirementResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequirementsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.marginpb.Requirement.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.marginpb.RequirementSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Requirement requirements = 1;
 * @return {!Array<!proto.marginpb.Requirement>}
 */
proto.marginpb.ListRequirementResponse.prototype.getRequirementsList = function() {
  return /** @type{!Array<!proto.marginpb.Requirement>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.marginpb.Requirement, 1));
};


/**
 * @param {!Array<!proto.marginpb.Requirement>} value
 * @return {!proto.marginpb.ListRequirementResponse} returns this
*/
proto.marginpb.ListRequirementResponse.prototype.setRequirementsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.marginpb.Requirement=} opt_value
 * @param {number=} opt_index
 * @return {!proto.marginpb.Requirement}
 */
proto.marginpb.ListRequirementResponse.prototype.addRequirements = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.marginpb.Requirement, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.marginpb.ListRequirementResponse} returns this
 */
proto.marginpb.ListRequirementResponse.prototype.clearRequirementsList = function() {
  return this.setRequirementsList([]);
};


/**
 * optional RequirementSummary summary = 2;
 * @return {?proto.marginpb.RequirementSummary}
 */
proto.marginpb.ListRequirementResponse.prototype.getSummary = function() {
  return /** @type{?proto.marginpb.RequirementSummary} */ (
    jspb.Message.getWrapperField(this, proto.marginpb.RequirementSummary, 2));
};


/**
 * @param {?proto.marginpb.RequirementSummary|undefined} value
 * @return {!proto.marginpb.ListRequirementResponse} returns this
*/
proto.marginpb.ListRequirementResponse.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.marginpb.ListRequirementResponse} returns this
 */
proto.marginpb.ListRequirementResponse.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.marginpb.ListRequirementResponse.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.marginpb.RequirementSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.marginpb.RequirementSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.marginpb.RequirementSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marginpb.RequirementSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalEquity: jspb.Message.getFieldWithDefault(msg, 1, ""),
    exchangeReq: jspb.Message.getFieldWithDefault(msg, 2, ""),
    exchangeCall: jspb.Message.getFieldWithDefault(msg, 3, ""),
    fedReq: jspb.Message.getFieldWithDefault(msg, 4, ""),
    fedCall: jspb.Message.getFieldWithDefault(msg, 5, ""),
    houseReq: jspb.Message.getFieldWithDefault(msg, 6, ""),
    houseCall: jspb.Message.getFieldWithDefault(msg, 7, ""),
    buyingPowerCall: jspb.Message.getFieldWithDefault(msg, 8, ""),
    minBalanceCall: jspb.Message.getFieldWithDefault(msg, 9, ""),
    houseExcess: jspb.Message.getFieldWithDefault(msg, 10, ""),
    adjFedReq: jspb.Message.getFieldWithDefault(msg, 11, ""),
    adjExchangeReq: jspb.Message.getFieldWithDefault(msg, 12, ""),
    adjHouseReq: jspb.Message.getFieldWithDefault(msg, 36, ""),
    longOptionMarketValue: jspb.Message.getFieldWithDefault(msg, 13, ""),
    shortOptionMarketValue: jspb.Message.getFieldWithDefault(msg, 14, ""),
    totalRows: jspb.Message.getFieldWithDefault(msg, 15, 0),
    pmHouseCall: jspb.Message.getFieldWithDefault(msg, 16, ""),
    pmHouseReq: jspb.Message.getFieldWithDefault(msg, 17, ""),
    timsCall: jspb.Message.getFieldWithDefault(msg, 18, ""),
    timsReq: jspb.Message.getFieldWithDefault(msg, 19, ""),
    marginEquity: jspb.Message.getFieldWithDefault(msg, 20, ""),
    fedExcess: jspb.Message.getFieldWithDefault(msg, 21, ""),
    exchangeExcess: jspb.Message.getFieldWithDefault(msg, 22, ""),
    minBalanceExcess: jspb.Message.getFieldWithDefault(msg, 23, ""),
    minBalanceReq: jspb.Message.getFieldWithDefault(msg, 24, ""),
    totalAdjustmentFedReq: jspb.Message.getFieldWithDefault(msg, 25, ""),
    totalAdjustmentHouseReq: jspb.Message.getFieldWithDefault(msg, 26, ""),
    totalAdjustmentExchangeReq: jspb.Message.getFieldWithDefault(msg, 27, ""),
    cashCallReq: jspb.Message.getFieldWithDefault(msg, 28, ""),
    cashCall: jspb.Message.getFieldWithDefault(msg, 29, ""),
    freeRidingReq: jspb.Message.getFieldWithDefault(msg, 30, ""),
    freeRidingCall: jspb.Message.getFieldWithDefault(msg, 31, ""),
    overnightBuyingPower: jspb.Message.getFieldWithDefault(msg, 32, ""),
    pmHouseExcess: jspb.Message.getFieldWithDefault(msg, 33, ""),
    timsExcess: jspb.Message.getFieldWithDefault(msg, 34, ""),
    isArchived: jspb.Message.getBooleanFieldWithDefault(msg, 35, false),
    cashBalance: jspb.Message.getFieldWithDefault(msg, 37, ""),
    longMarketValue: jspb.Message.getFieldWithDefault(msg, 38, ""),
    shortMarketValue: jspb.Message.getFieldWithDefault(msg, 39, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.marginpb.RequirementSummary}
 */
proto.marginpb.RequirementSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.marginpb.RequirementSummary;
  return proto.marginpb.RequirementSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.marginpb.RequirementSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.marginpb.RequirementSummary}
 */
proto.marginpb.RequirementSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalEquity(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchangeReq(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchangeCall(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFedReq(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFedCall(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setHouseReq(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setHouseCall(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuyingPowerCall(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinBalanceCall(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setHouseExcess(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjFedReq(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjExchangeReq(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjHouseReq(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongOptionMarketValue(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortOptionMarketValue(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalRows(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setPmHouseCall(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setPmHouseReq(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimsCall(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimsReq(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginEquity(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setFedExcess(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchangeExcess(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinBalanceExcess(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinBalanceReq(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalAdjustmentFedReq(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalAdjustmentHouseReq(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalAdjustmentExchangeReq(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setCashCallReq(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setCashCall(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setFreeRidingReq(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setFreeRidingCall(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setOvernightBuyingPower(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setPmHouseExcess(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimsExcess(value);
      break;
    case 35:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsArchived(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setCashBalance(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongMarketValue(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortMarketValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.marginpb.RequirementSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.marginpb.RequirementSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.marginpb.RequirementSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marginpb.RequirementSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalEquity();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExchangeReq();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExchangeCall();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFedReq();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFedCall();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getHouseReq();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getHouseCall();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBuyingPowerCall();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getMinBalanceCall();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getHouseExcess();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getAdjFedReq();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAdjExchangeReq();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAdjHouseReq();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getLongOptionMarketValue();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getShortOptionMarketValue();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeUint32(
      15,
      f
    );
  }
  f = message.getPmHouseCall();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getPmHouseReq();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getTimsCall();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getTimsReq();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getMarginEquity();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getFedExcess();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getExchangeExcess();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getMinBalanceExcess();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getMinBalanceReq();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getTotalAdjustmentFedReq();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getTotalAdjustmentHouseReq();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getTotalAdjustmentExchangeReq();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getCashCallReq();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getCashCall();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getFreeRidingReq();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getFreeRidingCall();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getOvernightBuyingPower();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getPmHouseExcess();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getTimsExcess();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getIsArchived();
  if (f) {
    writer.writeBool(
      35,
      f
    );
  }
  f = message.getCashBalance();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
};


/**
 * optional string total_equity = 1;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getTotalEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setTotalEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string exchange_req = 2;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getExchangeReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setExchangeReq = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string exchange_call = 3;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getExchangeCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setExchangeCall = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string fed_req = 4;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getFedReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setFedReq = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string fed_call = 5;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getFedCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setFedCall = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string house_req = 6;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string house_call = 7;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getHouseCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setHouseCall = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string buying_power_call = 8;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getBuyingPowerCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setBuyingPowerCall = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string min_balance_call = 9;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getMinBalanceCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setMinBalanceCall = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string house_excess = 10;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getHouseExcess = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setHouseExcess = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string adj_fed_req = 11;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getAdjFedReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setAdjFedReq = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string adj_exchange_req = 12;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getAdjExchangeReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setAdjExchangeReq = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string adj_house_req = 36;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getAdjHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setAdjHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string long_option_market_value = 13;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getLongOptionMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setLongOptionMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string short_option_market_value = 14;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getShortOptionMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setShortOptionMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional uint32 total_rows = 15;
 * @return {number}
 */
proto.marginpb.RequirementSummary.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setTotalRows = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string pm_house_call = 16;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getPmHouseCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setPmHouseCall = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string pm_house_req = 17;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getPmHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setPmHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string tims_call = 18;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getTimsCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setTimsCall = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string tims_req = 19;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getTimsReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setTimsReq = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string margin_equity = 20;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getMarginEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setMarginEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string fed_excess = 21;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getFedExcess = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setFedExcess = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string exchange_excess = 22;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getExchangeExcess = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setExchangeExcess = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string min_balance_excess = 23;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getMinBalanceExcess = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setMinBalanceExcess = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string min_balance_req = 24;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getMinBalanceReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setMinBalanceReq = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string total_adjustment_fed_req = 25;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getTotalAdjustmentFedReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setTotalAdjustmentFedReq = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string total_adjustment_house_req = 26;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getTotalAdjustmentHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setTotalAdjustmentHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string total_adjustment_exchange_req = 27;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getTotalAdjustmentExchangeReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setTotalAdjustmentExchangeReq = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string cash_call_req = 28;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getCashCallReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setCashCallReq = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string cash_call = 29;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getCashCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setCashCall = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string free_riding_req = 30;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getFreeRidingReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setFreeRidingReq = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string free_riding_call = 31;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getFreeRidingCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setFreeRidingCall = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string overnight_buying_power = 32;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getOvernightBuyingPower = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setOvernightBuyingPower = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string pm_house_excess = 33;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getPmHouseExcess = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setPmHouseExcess = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional string tims_excess = 34;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getTimsExcess = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setTimsExcess = function(value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional bool is_archived = 35;
 * @return {boolean}
 */
proto.marginpb.RequirementSummary.prototype.getIsArchived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 35, false));
};


/**
 * @param {boolean} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setIsArchived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 35, value);
};


/**
 * optional string cash_balance = 37;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getCashBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setCashBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string long_market_value = 38;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string short_market_value = 39;
 * @return {string}
 */
proto.marginpb.RequirementSummary.prototype.getShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementSummary} returns this
 */
proto.marginpb.RequirementSummary.prototype.setShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.marginpb.ListRequirementDetailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.marginpb.ListRequirementDetailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.marginpb.ListRequirementDetailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marginpb.ListRequirementDetailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tradeDate: (f = msg.getTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pagination: (f = msg.getPagination()) && proto_utilspb_pagination_pb.Pagination.toObject(includeInstance, f),
    pmHouseReq: jspb.Message.getFieldWithDefault(msg, 4, ""),
    timsReq: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.marginpb.ListRequirementDetailRequest}
 */
proto.marginpb.ListRequirementDetailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.marginpb.ListRequirementDetailRequest;
  return proto.marginpb.ListRequirementDetailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.marginpb.ListRequirementDetailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.marginpb.ListRequirementDetailRequest}
 */
proto.marginpb.ListRequirementDetailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setTradeDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 3:
      var value = new proto_utilspb_pagination_pb.Pagination;
      reader.readMessage(value,proto_utilspb_pagination_pb.Pagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPmHouseReq(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimsReq(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.marginpb.ListRequirementDetailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.marginpb.ListRequirementDetailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.marginpb.ListRequirementDetailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marginpb.ListRequirementDetailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTradeDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto_utilspb_pagination_pb.Pagination.serializeBinaryToWriter
    );
  }
  f = message.getPmHouseReq();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTimsReq();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional google.type.Date trade_date = 1;
 * @return {?proto.google.type.Date}
 */
proto.marginpb.ListRequirementDetailRequest.prototype.getTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.marginpb.ListRequirementDetailRequest} returns this
*/
proto.marginpb.ListRequirementDetailRequest.prototype.setTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.marginpb.ListRequirementDetailRequest} returns this
 */
proto.marginpb.ListRequirementDetailRequest.prototype.clearTradeDate = function() {
  return this.setTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.marginpb.ListRequirementDetailRequest.prototype.hasTradeDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string master_account_no = 2;
 * @return {string}
 */
proto.marginpb.ListRequirementDetailRequest.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.ListRequirementDetailRequest} returns this
 */
proto.marginpb.ListRequirementDetailRequest.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional utilspb.Pagination pagination = 3;
 * @return {?proto.utilspb.Pagination}
 */
proto.marginpb.ListRequirementDetailRequest.prototype.getPagination = function() {
  return /** @type{?proto.utilspb.Pagination} */ (
    jspb.Message.getWrapperField(this, proto_utilspb_pagination_pb.Pagination, 3));
};


/**
 * @param {?proto.utilspb.Pagination|undefined} value
 * @return {!proto.marginpb.ListRequirementDetailRequest} returns this
*/
proto.marginpb.ListRequirementDetailRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.marginpb.ListRequirementDetailRequest} returns this
 */
proto.marginpb.ListRequirementDetailRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.marginpb.ListRequirementDetailRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string pm_house_req = 4;
 * @return {string}
 */
proto.marginpb.ListRequirementDetailRequest.prototype.getPmHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.ListRequirementDetailRequest} returns this
 */
proto.marginpb.ListRequirementDetailRequest.prototype.setPmHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string tims_req = 5;
 * @return {string}
 */
proto.marginpb.ListRequirementDetailRequest.prototype.getTimsReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.ListRequirementDetailRequest} returns this
 */
proto.marginpb.ListRequirementDetailRequest.prototype.setTimsReq = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.marginpb.ListRequirementDetailResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.marginpb.ListRequirementDetailResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.marginpb.ListRequirementDetailResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.marginpb.ListRequirementDetailResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marginpb.ListRequirementDetailResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requirementDetailsList: jspb.Message.toObjectList(msg.getRequirementDetailsList(),
    proto.marginpb.RequirementDetail.toObject, includeInstance),
    summary: (f = msg.getSummary()) && proto.marginpb.RequirementDetailSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.marginpb.ListRequirementDetailResponse}
 */
proto.marginpb.ListRequirementDetailResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.marginpb.ListRequirementDetailResponse;
  return proto.marginpb.ListRequirementDetailResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.marginpb.ListRequirementDetailResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.marginpb.ListRequirementDetailResponse}
 */
proto.marginpb.ListRequirementDetailResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.marginpb.RequirementDetail;
      reader.readMessage(value,proto.marginpb.RequirementDetail.deserializeBinaryFromReader);
      msg.addRequirementDetails(value);
      break;
    case 2:
      var value = new proto.marginpb.RequirementDetailSummary;
      reader.readMessage(value,proto.marginpb.RequirementDetailSummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.marginpb.ListRequirementDetailResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.marginpb.ListRequirementDetailResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.marginpb.ListRequirementDetailResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marginpb.ListRequirementDetailResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequirementDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.marginpb.RequirementDetail.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.marginpb.RequirementDetailSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RequirementDetail requirement_details = 1;
 * @return {!Array<!proto.marginpb.RequirementDetail>}
 */
proto.marginpb.ListRequirementDetailResponse.prototype.getRequirementDetailsList = function() {
  return /** @type{!Array<!proto.marginpb.RequirementDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.marginpb.RequirementDetail, 1));
};


/**
 * @param {!Array<!proto.marginpb.RequirementDetail>} value
 * @return {!proto.marginpb.ListRequirementDetailResponse} returns this
*/
proto.marginpb.ListRequirementDetailResponse.prototype.setRequirementDetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.marginpb.RequirementDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.marginpb.RequirementDetail}
 */
proto.marginpb.ListRequirementDetailResponse.prototype.addRequirementDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.marginpb.RequirementDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.marginpb.ListRequirementDetailResponse} returns this
 */
proto.marginpb.ListRequirementDetailResponse.prototype.clearRequirementDetailsList = function() {
  return this.setRequirementDetailsList([]);
};


/**
 * optional RequirementDetailSummary summary = 2;
 * @return {?proto.marginpb.RequirementDetailSummary}
 */
proto.marginpb.ListRequirementDetailResponse.prototype.getSummary = function() {
  return /** @type{?proto.marginpb.RequirementDetailSummary} */ (
    jspb.Message.getWrapperField(this, proto.marginpb.RequirementDetailSummary, 2));
};


/**
 * @param {?proto.marginpb.RequirementDetailSummary|undefined} value
 * @return {!proto.marginpb.ListRequirementDetailResponse} returns this
*/
proto.marginpb.ListRequirementDetailResponse.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.marginpb.ListRequirementDetailResponse} returns this
 */
proto.marginpb.ListRequirementDetailResponse.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.marginpb.ListRequirementDetailResponse.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.marginpb.RequirementDetailSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.marginpb.RequirementDetailSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.marginpb.RequirementDetailSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marginpb.RequirementDetailSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    longQty: jspb.Message.getFieldWithDefault(msg, 1, ""),
    shortQty: jspb.Message.getFieldWithDefault(msg, 2, ""),
    previousQty: jspb.Message.getFieldWithDefault(msg, 3, ""),
    longMarketValue: jspb.Message.getFieldWithDefault(msg, 4, ""),
    shortMarketValue: jspb.Message.getFieldWithDefault(msg, 5, ""),
    marketValue: jspb.Message.getFieldWithDefault(msg, 6, ""),
    previousMarketValue: jspb.Message.getFieldWithDefault(msg, 7, ""),
    exchangeReq: jspb.Message.getFieldWithDefault(msg, 8, ""),
    houseReq: jspb.Message.getFieldWithDefault(msg, 9, ""),
    fedReq: jspb.Message.getFieldWithDefault(msg, 10, ""),
    adjFedReq: jspb.Message.getFieldWithDefault(msg, 11, ""),
    adjExchangeReq: jspb.Message.getFieldWithDefault(msg, 12, ""),
    adjHouseReq: jspb.Message.getFieldWithDefault(msg, 36, ""),
    longOptionMarketValue: jspb.Message.getFieldWithDefault(msg, 13, ""),
    shortOptionMarketValue: jspb.Message.getFieldWithDefault(msg, 14, ""),
    totalRows: jspb.Message.getFieldWithDefault(msg, 15, 0),
    pmHouseReq: jspb.Message.getFieldWithDefault(msg, 16, ""),
    timsReq: jspb.Message.getFieldWithDefault(msg, 17, ""),
    totalAdjustmentFedReq: jspb.Message.getFieldWithDefault(msg, 18, ""),
    totalAdjustmentHouseReq: jspb.Message.getFieldWithDefault(msg, 19, ""),
    totalAdjustmentExchangeReq: jspb.Message.getFieldWithDefault(msg, 20, ""),
    qty: jspb.Message.getFieldWithDefault(msg, 21, ""),
    costBasis: jspb.Message.getFieldWithDefault(msg, 23, ""),
    costPrice: jspb.Message.getFieldWithDefault(msg, 24, ""),
    isArchived: jspb.Message.getBooleanFieldWithDefault(msg, 22, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.marginpb.RequirementDetailSummary}
 */
proto.marginpb.RequirementDetailSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.marginpb.RequirementDetailSummary;
  return proto.marginpb.RequirementDetailSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.marginpb.RequirementDetailSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.marginpb.RequirementDetailSummary}
 */
proto.marginpb.RequirementDetailSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongQty(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortQty(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviousQty(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongMarketValue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortMarketValue(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketValue(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviousMarketValue(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchangeReq(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setHouseReq(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setFedReq(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjFedReq(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjExchangeReq(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjHouseReq(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongOptionMarketValue(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortOptionMarketValue(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalRows(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setPmHouseReq(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimsReq(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalAdjustmentFedReq(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalAdjustmentHouseReq(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalAdjustmentExchangeReq(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setQty(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setCostBasis(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setCostPrice(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsArchived(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.marginpb.RequirementDetailSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.marginpb.RequirementDetailSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.marginpb.RequirementDetailSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marginpb.RequirementDetailSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLongQty();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShortQty();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPreviousQty();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMarketValue();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPreviousMarketValue();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getExchangeReq();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getHouseReq();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getFedReq();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getAdjFedReq();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAdjExchangeReq();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAdjHouseReq();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getLongOptionMarketValue();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getShortOptionMarketValue();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeUint32(
      15,
      f
    );
  }
  f = message.getPmHouseReq();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getTimsReq();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getTotalAdjustmentFedReq();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getTotalAdjustmentHouseReq();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getTotalAdjustmentExchangeReq();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getQty();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getCostBasis();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getCostPrice();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getIsArchived();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
};


/**
 * optional string long_qty = 1;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getLongQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setLongQty = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string short_qty = 2;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getShortQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setShortQty = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string previous_qty = 3;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getPreviousQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setPreviousQty = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string long_market_value = 4;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string short_market_value = 5;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string market_value = 6;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string previous_market_value = 7;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getPreviousMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setPreviousMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string exchange_req = 8;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getExchangeReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setExchangeReq = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string house_req = 9;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string fed_req = 10;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getFedReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setFedReq = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string adj_fed_req = 11;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getAdjFedReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setAdjFedReq = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string adj_exchange_req = 12;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getAdjExchangeReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setAdjExchangeReq = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string adj_house_req = 36;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getAdjHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setAdjHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string long_option_market_value = 13;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getLongOptionMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setLongOptionMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string short_option_market_value = 14;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getShortOptionMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setShortOptionMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional uint32 total_rows = 15;
 * @return {number}
 */
proto.marginpb.RequirementDetailSummary.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setTotalRows = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string pm_house_req = 16;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getPmHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setPmHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string tims_req = 17;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getTimsReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setTimsReq = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string total_adjustment_fed_req = 18;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getTotalAdjustmentFedReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setTotalAdjustmentFedReq = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string total_adjustment_house_req = 19;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getTotalAdjustmentHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setTotalAdjustmentHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string total_adjustment_exchange_req = 20;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getTotalAdjustmentExchangeReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setTotalAdjustmentExchangeReq = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string qty = 21;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setQty = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string cost_basis = 23;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getCostBasis = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setCostBasis = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string cost_price = 24;
 * @return {string}
 */
proto.marginpb.RequirementDetailSummary.prototype.getCostPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setCostPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional bool is_archived = 22;
 * @return {boolean}
 */
proto.marginpb.RequirementDetailSummary.prototype.getIsArchived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.marginpb.RequirementDetailSummary} returns this
 */
proto.marginpb.RequirementDetailSummary.prototype.setIsArchived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


goog.object.extend(exports, proto.marginpb);
